import React, { useState, useEffect } from "react";
import { intl } from "LocaleWrapper";
import DOMPurify from "dompurify";

import { Table, Button, FormGroup } from "@cofano/cck";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import { request } from "components/utils/Request2";

import { Language, DataFormat } from "imports/Utils";
import { ShipLink, VoyageLink } from "utils/LinkUtils";
import { FormattedDate } from "utils/DateUtils";

export const NotificationDetailsDialog = ({ open, onClose, notification, isOutbox, refetch }) => {

	const [ receivers, setReceivers ] = useState([]);

	useEffect(() => {

		if (notification?.id && isOutbox) {
			request({
				url: `insystemnotifications/${notification?.id}`,
			}).then((response) => {
				const list = response.receiverList || [];
				setReceivers(list.map((item) => ({ id: item.user?.id, ...item })));
			});
		}

		if (notification?.id && !notification.read && !isOutbox) {
			request({
				url: `insystemnotifications/read/${notification?.id}`,
				method: "PUT",
			}).then(() => refetch());
		}
	}, [ notification?.id ]);

	return (
		<Dialog open={open}
			onClose={onClose}
			maxWidth="md"
			fullWidth>
			<DialogTitle>
				{Language("NOTIFICATION")}
			</DialogTitle>

			<DialogContent dividers>
				<FormGroup label={Language("NOTIFICATION_SENDER")} overflow="hidden">
					{notification ? (notification?.sender?.username || intl.formatMessage({ id: "NOTIFICATION_SYSTEM_SENDER" })) : "-"}
				</FormGroup>

				<FormGroup label={Language("NOTIFICATION_SUBJECT")} overflow="hidden">
					{notification?.subject || "-"}
				</FormGroup>

				<FormGroup label={Language("DATE")} overflow="hidden">
					{notification ? <FormattedDate date={notification.createdOn} /> : "-"}
				</FormGroup>

				{notification?.ship && (
					<FormGroup label={Language("SHIP")} overflow="hidden">
						<ShipLink ship={notification.ship} />
					</FormGroup>
				)}

				{notification?.voyage && (
					<FormGroup label={Language("VOYAGE")} overflow="hidden">
						<VoyageLink voyage={notification.voyage} />
					</FormGroup>
				)}

				<FormGroup label={Language("NOTIFICATION_TYPE_MESSAGE")} overflow="hidden">
					<div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(notification?.body) }} />
				</FormGroup>

				{receivers.length > 0 && (
					<div>
						<Table
							title={Language("RECEIVERS")}
							content={receivers}
							disableFooter={true}
							columns={[ {
								id: "user.username",
								title: intl.formatMessage({ id: "NOTIFICATION_RECEIVER" }),
							}, {
								id: "readOn",
								title: intl.formatMessage({ id: "NOTIFICATION_READED" }),
								render: (row) => row.readOn ? <FormattedDate date={row.readOn} /> : DataFormat.boolean(false),
							} ]} />
					</div>
				)}
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} size="small" variant="outlined">{Language("CLOSE")}</Button>
			</DialogActions>
		</Dialog>
	);
};
